import { FC, Fragment, useEffect, useState } from 'react';

import { useTranslation } from '@crehana/i18n';
import CheckmarkCircle from '@crehana/icons/fill/CheckmarkCircle';
import { primaryMain } from '@crehana/ui/dist/styles/colors';

type TCountProps = {
  setNextStep(): void;
  init: boolean;
};

const Count: FC<React.PropsWithChildren<TCountProps>> = ({
  setNextStep,
  init,
}) => {
  const [count, setCount] = useState(0);
  const { t } = useTranslation();

  const increaseCounter = () => {
    setCount(count => count + 1);
  };

  useEffect(() => {
    if (init) {
      const interval = setInterval(increaseCounter, 25);
      return () => clearInterval(interval);
    }
  }, [init]);

  useEffect(() => {
    if (count > 99) {
      setNextStep();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  return (
    <Fragment>
      {count < 99 ? (
        <span className="font-poppins font-normal text-16 ml-8 text-white">
          {Math.round(count)}%
        </span>
      ) : (
        <div className="flex justify-end items-center w-1/2">
          <CheckmarkCircle size={24} color={primaryMain} />
          <span className="font-poppins font-normal text-16 ml-8 text-white">
            {t('LOADER_FINAL_COUNT_TITLE')}
          </span>
        </div>
      )}
    </Fragment>
  );
};

export default Count;
